/**
 * Resolve a graph node uid from a click target.
 * Media cards (img-div / video-div) and text inputs carry the node uid as their DOM id;
 * circle clicks need the parent <g> and a foreignObject descendant lookup.
 */
export const resolveNodeUidFromEventTarget = (target: EventTarget | null): string | undefined => {
	if (!target || typeof (target as Element).closest !== 'function') {
		return undefined;
	}
	const element = target as Element;

	const host = element.closest(
		'.img-div, .video-div, .input, .pdf-node-card, .positioning-board-card, .synthesise-output-header'
	) as HTMLElement | null;
	if (host?.id) {
		return host.id;
	}

	const parent = element.parentNode as Element | null;
	if (!parent || typeof parent.querySelector !== 'function') {
		return undefined;
	}

	const fromParent = parent.querySelector<HTMLElement>(
		'foreignObject > a > .input, foreignObject > div.img-div, foreignObject > div.video-div, foreignObject > div'
	);
	if (fromParent?.id) {
		return fromParent.id;
	}

	const bound = (parent as Element & { __data__?: { uid?: string } }).__data__;
	return bound?.uid;
};
